import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { PreviewContainer, PreviewWrapper } from "./mobilePreview.style";
import MobileMockup from "../../../Common/UI/MobileMockup";
import { ChevronLeft } from "@mui/icons-material";
import { useAppSelector } from "../../../../Redux/hooks";
import MobConsentBlock from "./MobConsentBlock";

const MobilePreview = () => {
  const blocks = useAppSelector((state) => state.consent.blocks);
  const consentName = useAppSelector((state) => state.consent.consentName);

  return (
    <Box sx={PreviewWrapper}>
      <MobileMockup>
        <Stack sx={PreviewContainer}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              height: "35px",
              position: "relative",
              borderBottom: "1px solid #E5E7EB",
              px: "10px",
            }}
          >
            <ChevronLeft />

            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                maxWidth: "15ch",
              }}
            >
              <Typography
                variant="subtitle1"
                overflow={"hidden"}
                textOverflow={"ellipsis"}
                whiteSpace={"nowrap"}
              >
                {consentName || "Form Preview"}
              </Typography>
            </Box>
          </Box>

          {blocks.length > 0 && (
            <Stack
              gap={2}
              sx={{
                height: "100%",
                overflowY: "hidden",
                px: "15px",
                pt: 1,
                "&:hover": {
                  overflow: "auto",
                },
                "&::-webkit-scrollbar": {
                  width: "4px",
                },
              }}
            >
              {blocks.map((block) => (
                <MobConsentBlock block={block} key={block.id} />
              ))}
              <Box sx={{ py: 2 }}>
                <Button fullWidth variant="contained">
                  Submit
                </Button>
              </Box>
            </Stack>
          )}
        </Stack>
      </MobileMockup>
    </Box>
  );
};

export default MobilePreview;
